import serviceHandler from "@/helpers/handlers/service";
import gmbAttributesService from "@/services/gmbAttributes";
import { GmbAttributeValueType } from "@/enums/gmb-attribute-value-type";

const mapAttributes = (available = [], current = []) => {
  const getValues = attributeId => {
    const attr = current.find(
      ({ gmb_attribute }) => attributeId === gmb_attribute.attribute_id
    );

    if (attr) {
      if (
        attr.gmb_attribute.value_type === GmbAttributeValueType.BOOL ||
        attr.gmb_attribute.value_type === GmbAttributeValueType.ENUM
      ) {
        return attr.values[0];
      }

      return attr.values;
    }

    return null;
  };

  return available.map(attr => {
    let options;
    if (
      attr.value_type === GmbAttributeValueType.ENUM ||
      attr.value_type === GmbAttributeValueType.REPEATED_ENUM
    ) {
      options = {
        options: attr.value_metadata.map(meta => ({
          displayName: meta.displayName,
          name: meta.value
        }))
      };
    }

    return {
      id: attr.id,
      attributeId: attr.attribute_id,
      type: attr.value_type,
      groupName: attr.group_display_name,
      displayName: attr.display_name,
      value: getValues(attr.attribute_id),
      ...options
    };
  });
};

export default {
  resetStore({ commit }) {
    commit("RESET_STORE");
  },

  async fetchAvailableAttributes(
    { commit, state },
    {
      facilitiesIds = [],
      onlySet = false,
      valueTypes = [],
      activeAttributes = []
    }
  ) {
    const result = await serviceHandler(
      gmbAttributesService.fetchAvailableGmbAttributes({
        facilitiesIds,
        onlySet,
        valueTypes
      })
    );

    const attributes = mapAttributes(result, activeAttributes);
    commit("SET_ATTRIBUTES", attributes || []);
    commit("SET_AVAILABLE_ATTRIBUTES", result || []);
  },

  findAttribute({ state }, attributeId) {
    return state.attributes.find(attr => attr.attributeId === attributeId);
  },

  updateAttribute({ commit, state }, { attributeId, value }) {
    const attributes = [...state.attributes];
    const attributeIndex = attributes.findIndex(
      attr => attr.attributeId === attributeId
    );

    if (attributeIndex > -1) {
      attributes[attributeIndex].value = value;
    }

    commit("SET_ATTRIBUTES", attributes);
  }
};
